import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useNavigate } from "react-router-dom";
import SideModal from '/src/components/modal/SideModal/SideModal'
import useModalHelper from "/src/components/modal/hooks/useModalHelper";

import PhoneModalBody from "./PhoneModalBody"
import companyService from "../../../company/services/companyService"


import "./PhoneModal.css"
import "/src/assets/css/polices.css";

const PhoneModal = NiceModal.create(({ title, data }) => {
    const modal = useModal();

    const { onClose } = useModalHelper(modal);
    const { getCompany } = companyService;

    //const form = { title: title, id: data == undefined ? null : data.id, channel: data == undefined ? null : data.channel, company: data == undefined ? null : data.company, country: data == undefined ? null : data.country, libelle: data == undefined ? null : data.libelle, numbers: data == undefined ? null : data.numbers, max_simultaneous_call : data == undefined ? null : data.max_simultaneous_call, is_mutu : data == undefined ? null : data.is_mutu }
    const form = {title, ...data};
    return (
        <SideModal name="change-password" id={modal.id} autoClose="true" onClose={onClose}>
            <div>
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })}  >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>

            <PhoneModalBody form={form}></PhoneModalBody>

        </SideModal >
    )
});

export default PhoneModal;